import { useEffect } from "react";

const Gtag = ({ gtagId }) => {
  useEffect(() => {
    if (!gtagId) {
      return;
    }

    // Load the Google Tag Manager script dynamically
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    script.async = true;
    document.head.appendChild(script);

    // Inject the gtag initialization script
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gtagId}');
    `;
    document.head.appendChild(inlineScript);

    return () => {
      // Cleanup scripts if needed
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, [gtagId]);

  return null; // No JSX to render
};

export default Gtag;
